module.exports = __webpack_public_path__ + "img/12_Anmeldung-Screen@2x.b42faa95.png";